<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div class="btn btn-hover bg-secondary-color">Reviews</div>
      <div class="big-caption text-default-color">
        Customer's feedbacks <br />
        & Testimonials
      </div>
      <p style="text-align: center">
        We're always happy to serve lots of innovative brands and businesses in
        <br />
        Africa. Here's a glimpse of what they say about HuiosPay
      </p>
    </div>
  </div>

  <div class="container d-flexbox row flex-wrap">
    <div
      class="review-card d-flexbox col justify-content-left align-items-left"
      *ngFor="let item of testimonies"
    >
      <div class="reviewer-logo"><img [src]="logo" alt="" /></div>
      <div class="review">
        <div
          class="smaller-caption no-bold text-align-left pl-0 caption-primary-color"
        >
          {{ item?.caption }}
        </div>
        <p class="content text-secondary-color">
          {{ item?.review }}
        </p>
      </div>
      <div
        class="reviewer-details d-flexbox row justify-content-left align-items-right"
      >
        <img [src]="avatar" width="50" height="50" alt="" />
        <div>
          <span class="name">{{ item?.name }}</span> <br />
          <!-- <span class="title"> {{ item?.position }}</span> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

  <app-back-to-top
    [acceleration]="2"
    [animate]="true"
    [scrollDistance]="50"
    [speed]="50"
  >
  </app-back-to-top>
</div>
